/**************************************
 ** AtlasImageLoader
 *
 *  This object loads the images in a series of batches.  Between each batch the loader will check to see
 *  if an override is requested, if so then it will priority load that image if it is not currently loaded.
 *  Once an image is loaded it is stored in the image cache
 *
 *  Queue - the loading queue from which the batches will be pulled
 *  CurrentBatch - the currently loading batch
 *  Override - the override image to load
 *  LoadingQueue -
 ***************************************/
define('atlas/AtlasImageLoader', ['atlas/AtlasApplication'], function(Application) {
    'use strict';

    var AtlasImageLoader = function() {
        this._currentBatch = 0;
        this._loadingQueue = [];

        this._cancelLoading = false;

        this._imageSubscribers = [];
        this._batchSubscribers = [];
        this._completedSubscribers = [];
        this._progressSubscribers = [];

        //list of currently loaded images by resolution
        this._loadedList = {};
    };

    AtlasImageLoader.prototype.addImageSubscriber = function(callback, data) {
        var imageSubscriber = {
            callback: callback,
            data: data
        };
        this._imageSubscribers.push(imageSubscriber);
    };

    AtlasImageLoader.prototype.clearImageSubscribers = function() {
        this._imageSubscribers = [];
    };

    AtlasImageLoader.prototype.addBatchSubscriber = function(callback, data) {
        var batchSubscriber = {
            callback: callback,
            data: data
        };
        this._batchSubscribers.push(batchSubscriber);
    };

    AtlasImageLoader.prototype.clearBatchSubscribers = function() {
        this._batchSubscribers = [];
    };

    AtlasImageLoader.prototype.addCompletedSubscriber = function(callback, data) {
        var completedSubscriber = {
            callback: callback,
            data: data
        };
        this._completedSubscribers.push(completedSubscriber);
    };

    AtlasImageLoader.prototype.clearCompletedSubscribers = function() {
        this._completedSubscribers = [];
    };

    AtlasImageLoader.prototype.addProgressSubscriber = function(callback, data) {
        var progressSubscriber = {
            callback: callback,
            data: data
        };
        this._progressSubscribers.push(progressSubscriber);
    };

    AtlasImageLoader.prototype.clearProgressSubscribers = function() {
        this._progressSubscribers = [];
    };

    AtlasImageLoader.prototype.cancel = function() {
        this._cancelLoading = true;

        this._currentBatch = 0;
        this._loadingQueue = [];

        this._imageSubscribers = [];
        this._batchSubscribers = [];
        this._completedSubscribers = [];
        this._progressSubscribers = [];

        this._loadedList = {};
    };

    AtlasImageLoader.prototype.addToLoadedList = function(resolution, index) {
        if (!this._loadedList.resolution) {
            this._loadedList.resolution = [];
        }
        if (this._loadedList.resolution.indexOf(index)<0) {
            this._loadedList.resolution.push(index);
        }
    };

    AtlasImageLoader.prototype.previouslyLoaded = function(resolution, index) {
        if (!this._loadedList.resolution) {
            return false;
        }
        if (this._loadedList.resolution.indexOf(index)<0) {
            return false;
        }

        return true;
    };

    AtlasImageLoader.prototype.load = function(queue, imageCache) {
        this._cancelLoading = false;

        //initiate loading
        this._queue = queue;
        this._imageCache = imageCache;
        //reset the current batch
        this._currentBatch = 0;

        Application._loadBatch(this._queue._batches[this._currentBatch++], this);

        Application._continueLoading(this);
    };

    AtlasImageLoader.prototype.forceOverride = function(index, resolution) {
        //go through the batches to find the index and resolution
        for (var b = 0; b < this._queue._batches.length; ++b) {
            for (var i = 0; i < this._queue._batches[i].images.length; ++i) {
                if ((this._queue._batches[b].images[i].index === index) && (this._queue._batches[b].images[i].resolution === resolution) &&
                    (!this._queue._batches[b].images[i].complete)) {
                    //save a copy of this item in the override holder
                    this._override = this._queue._batches[b].images[i];
                    this._override.batch = b;
                    //pull this item out - PROBLEM: this would cause batch ready messages to not be delivered if
                    //they were overridden, it should be okay to leave in the batch, it just won't get loaded again
                    //this._queue._batches[b].images.splice(i, 1);
                    return;
                }
            }
        }
    };

    return AtlasImageLoader;
});
